module.exports = __webpack_public_path__ + "img/about-our-message-bg.59932ce3.jpg";